"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["maxLines"],
    _excluded2 = ["content", "truncatedContent", "maxLines"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TruncatedBase = (0, _styledComponents["default"])(_primitives["default"].RawHtml).withConfig({
  displayName: "TruncatedTextComponent__TruncatedBase",
  componentId: "sc-1c4te39-0"
})((0, _styledSystem.system)({
  lineClamp: {
    property: "-webkit-line-clamp"
  }
}));
var Truncated = (0, _styledComponents["default"])(TruncatedBase).withConfig({
  displayName: "TruncatedTextComponent__Truncated",
  componentId: "sc-1c4te39-1"
})(["display:none;@supports (-webkit-line-clamp:1){display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;*{display:inline;}}"]);
var HideCharCount = (0, _styledComponents["default"])(function (_ref) {
  var maxLines = _ref.maxLines,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "TruncatedTextComponent__HideCharCount",
  componentId: "sc-1c4te39-2"
})(["", ""], function (_ref2) {
  var maxLines = _ref2.maxLines;
  return maxLines ? (0, _styledComponents.css)(["display:inherit;@supports (-webkit-line-clamp:1){display:none;}"]) : null;
});

var TruncatedTextComponent = function TruncatedTextComponent(_ref3) {
  var content = _ref3.content,
      truncatedContent = _ref3.truncatedContent,
      maxLines = _ref3.maxLines,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    tag: "div"
  }, props), maxLines && content && /*#__PURE__*/_react["default"].createElement(Truncated, {
    html: content,
    lineClamp: maxLines
  }), truncatedContent && truncatedContent.length > 0 && /*#__PURE__*/_react["default"].createElement(HideCharCount, {
    maxLines: maxLines
  }, (0, _utils.mapIndexed)(function (_ref4, index) {
    var display = _ref4.display,
        html = _ref4.html;
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
      key: index + "-" + html,
      display: display
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].RawHtml, {
      html: html
    }));
  }, truncatedContent)));
};

TruncatedTextComponent.propTypes = {
  content: _propTypes.string,
  maxLines: (0, _propTypes.arrayOf)(_propTypes.string),
  truncatedContent: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    display: (0, _propTypes.arrayOf)(_propTypes.string),
    hetml: _propTypes.string
  }))
};
var _default = TruncatedTextComponent;
exports["default"] = _default;